// extracted by mini-css-extract-plugin
export default {"wrapper":"styles-module__wrapper___zPTtb","badge":"styles-module__badge___t8RCl","icon":"styles-module__icon___lU-gD"};